import React from "react";
import { Link } from "react-router-dom";
import Button from "../shared/components/Button";
import ScrollAnimation from "../shared/components/animations/ScrollAnimation";
import PageInDev from "./../assets/png/pageInDev.png";

const PageInDevelopment = () => {
  return (
    <section className="bg-[#F3FAFF] h-screen flex flex-col justify-center items-center text-center px-4">
      <ScrollAnimation delay={0.6}>
        {/* Contenu principal */}
        <div className="flex flex-col items-center">
          {/* Image indicative du développement en cours */}
          <img
            src={PageInDev}
            alt="Page en cours de développement"
            className="w-1/3 mb-8"
          />

          {/* Texte informatif */}
          <h1 className="text-[#0369A1] text-4xl md:text-5xl font-bold mb-6">
            Page en cours de développement
          </h1>
          <p className="text-[#000000] text-lg md:text-xl mb-8">
            Nous travaillons dur pour vous offrir cette fonctionnalité. Merci de
            votre patience !
          </p>

          {/* Bouton de retour à l'accueil */}
          <Link
            to="/"
            className="text-white bg-[#F9CB4E] hover:bg-[#0369A1] transition-all px-6 py-3 rounded-lg">
            Retourner sur la page d’accueil
          </Link>
        </div>
      </ScrollAnimation>
    </section>
  );
};

export default PageInDevelopment;
